import React from 'react';
import { tenantNodes, actionsOf } from '../../../constants/featureCatalog';

const ACTION_LABEL = {
  view: 'Ver',
  create: 'Criar',
  edit: 'Editar',
  delete: 'Excluir',
  execute: 'Executar',
};

const WRITE_ACTIONS = ['create', 'edit', 'delete', 'execute'];

const PermissionsTree = ({ value, onChange }) => {
  const grants = value && typeof value === 'object' ? value : {};
  const nodes = tenantNodes();

  const setNodeActions = (key, actions) => {
    const next = { ...grants };
    if (!actions.length) {
      delete next[key];
    } else {
      next[key] = actionsOf(key).filter((a) => actions.includes(a));
    }
    onChange(next);
  };

  const toggleAction = (key, action) => {
    const current = new Set(grants[key] || []);
    if (current.has(action)) {
      current.delete(action);
      if (action === 'view') {
        WRITE_ACTIONS.forEach((a) => current.delete(a));
      }
    } else {
      current.add(action);
      if (WRITE_ACTIONS.includes(action)) current.add('view');
    }
    setNodeActions(key, Array.from(current));
  };

  return (
    <div className="permissions-tree box has-background-white-bis">
      <p className="has-text-weight-semibold mb-2">Permissões de acesso</p>
      <p className="is-size-7 has-text-grey mb-3">
        &quot;Ver&quot; é pré-requisito das demais ações. Sem nenhuma marcação salva, o usuário Técnico mantém o perfil técnico padrão; desmarcar tudo e salvar remove o acesso às Configurações.
      </p>
      <table className="table is-fullwidth is-narrow is-hoverable">
        <thead>
          <tr>
            <th>Módulo</th>
            <th className="has-text-centered">Ver</th>
            <th className="has-text-centered">Criar</th>
            <th className="has-text-centered">Editar</th>
            <th className="has-text-centered">Excluir/Executar</th>
          </tr>
        </thead>
        <tbody>
          {nodes.map((node) => {
            const supported = actionsOf(node.key);
            const current = new Set(grants[node.key] || []);
            const hasView = current.has('view');
            const writeCol = supported.includes('delete') ? 'delete' : (supported.includes('execute') ? 'execute' : null);
            const renderCell = (action) => {
              if (!supported.includes(action)) return <td className="has-text-centered has-text-grey-light">—</td>;
              const disabled = action !== 'view' && !hasView;
              return (
                <td className="has-text-centered">
                  <input
                    type="checkbox"
                    aria-label={`${node.label} ${ACTION_LABEL[action]}`}
                    checked={current.has(action)}
                    disabled={disabled}
                    onChange={() => toggleAction(node.key, action)}
                  />
                </td>
              );
            };
            return (
              <tr key={node.key}>
                <td>{node.label}</td>
                {renderCell('view')}
                {renderCell('create')}
                {renderCell('edit')}
                {writeCol ? renderCell(writeCol) : <td className="has-text-centered has-text-grey-light">—</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionsTree;
